import * as React from 'react';
import { ReactComponent as LogoutIconSVG } from '../../assets/icons/mevo/ic_logout.svg';
import IconPattern, { IconProps } from './_IconPattern';

const LogoutIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={LogoutIconSVG} variantPlaces={1} {...props} />;
};

export default LogoutIcon;
